export default (url) => {
  const userWindow = window.open(url, '_blank', 'noopener,noreferrer')
  // if the pop-up is blocked, redirect to the URL
  userWindow ? userWindow.opener = null : window.location.href = url
}
